import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PharmacistDashboard from "./pharmacist/PharmacistDashboard";
import ChangePassword from "./Landing/ChangePassword";
import { isActive, isInitialLoad } from "../actions/authAction";
import store from "../index";

import DashboardComponent from "./DashBoardComponent";

const MainDashboard = ({ roles, isAdmin, isNewUser, isActive }) => (

    <div>
        {!isActive && store.dispatch(isActive)}
        {isNewUser ? <ChangePassword /> :
            <div >
                {roles[0] === "PHARMACIST" && (isAdmin ? <DashboardComponent /> : <DashboardComponent />)}
                {roles[0] === "TECHNICIAN" && <DashboardComponent />}
            </div>}
    </div>
);

MainDashboard.propTypes = {
    roles: PropTypes.array.isRequired
};

MainDashboard.propTypes = {
    isActive: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        roles: state.auth.user.roles,
        isAdmin: state.auth.user.isAdmin,
        isNewUser: state.auth.user.isNewUser,
        isActive: state.auth.user.isActive,
    };
}

export default withRouter(connect(mapStateToProps, { isActive })(MainDashboard));
